module.exports = __webpack_public_path__ + "img/ic-left-menu-setting-02.110eff18.svg";